$(document).ready(function() {

// ----------------------------------------------------------------------------------
// Back-To-Top-Button
// ----------------------------------------------------------------------------------
    var $back2TopButton = $('<a href="#top" class="back2top hidden-xs"></a>').appendTo("body");
    $(window).scroll(function () {
        if (!$("body").hasClass("noscroll") && $(this).scrollTop() > 200) { // Wenn 200 Pixel gescrolled wurde
            $back2TopButton.fadeIn();
        } else {
            $back2TopButton.fadeOut();
        }
    });
    $back2TopButton.hide();
    $back2TopButton.click(function (e) { // Klick auf den Button
        e.preventDefault();
        $('body,html').animate({scrollTop: 0}, 500);
        return false;
    });










    // ----------------------------------------------------------------------------------
    // Fancy Input field preparation
    // ----------------------------------------------------------------------------------

    // Design-Element für Checkboxen
    $("input[type='checkbox'] + label").prepend("<span></span>");

    var $fancyInputFieldWrap = $("form").find(".kb-fancy-inputfield");
    if ($fancyInputFieldWrap.length > 0) {
        $fancyInputFieldWrap.find(".form-control").each(function() {
            if ($(this).val().trim().length > 0) {
                $(this).parents(".kb-fancy-inputfield").addClass("has-focus");
            }
            $(this).on("focus", function() { $(this).parents(".kb-fancy-inputfield").addClass("has-focus"); });
            $(this).on("blur", function() {
                if ($(this).val().trim() === "") {
                    $(this).parents(".kb-fancy-inputfield").removeClass("has-focus");
                }
            })
        });
    }



    // ----------------------------------------------------------------------------------
    // Team
    // ----------------------------------------------------------------------------------
    $('.contact-entry .video').hover(function() {
        $(this).find('video').get(0).currentTime=0;
        $(this).find('video').get(0).play();
    },function() {
        $(this).find('video').get(0).pause();
        $(this).find('video').get(0).currentTime=0;
    })


    //cookies
    $('#tx_cookies_accept input').click(
        function() {
            setTimeout(
                function() {
                    location.reload();
                },
                500);
        });


    $(document).on('click', '#scrollAhead', function() {
        var elem = $('#content');
        scrollToTarget(elem);
    });
});